import api from "@/router/api"

export default {
    getAllResponsibles({commit}, payload){
        return new Promise((resolve, reject) => {
            api.auxiliariesResponsible.list(payload)
            .then(response => {
                resolve(response.data.data)
                commit('SET_RESPONSIBLES', response.data.data)
            })
            .catch(error => {
                reject({
                    message: 'Ocurrió un problema al obtener los responsables',
                })
            })
        })
    },

    searchResponsibles({commit}, payload){
        return new Promise((resolve, reject) => {
            api.auxiliariesResponsible.search(payload)
                .then(response => {
                    resolve(response.data.data)
                    // SI NO VA EN ALGUN MOMENTO ALGO DE SEARCHRESPOSIBLES AQUI TENDRAS EL CULPABLE Y TENDRAS QUE QUITAR 1 DATA
                    commit('SET_RESPONSIBLES', response.data.data.data)
                })
                .catch(error => {
                    reject({
                        message: 'Ocurrió un problema al obtener los responsables',
                    })
                })
        })
    },


    findResponsibles({commit}, payload){

        return new Promise((resolve, reject) => {
            api.auxiliariesResponsible.find(payload)
                .then(response => {
                    resolve(response.data.data)
                    commit('SET_RESPONSIBLE', response.data.data)
                })
                .catch(error => {
                    reject({
                        message: 'Ocurrió un problema al obtener los responsables',
                    })
                })
        })
    },

    createResponsibles({commit}, payload){
        commit('CLEAR_VALIDATION')
        return new Promise((resolve, reject) => {
            api.auxiliariesResponsible.create(payload)
                .then(response => {
                    const {data} = response.data
                    commit('SET_RESPONSIBLES', response.data.data)
                    resolve(data)
                })
                .catch(error => {
                    const { data, status} = error.response
                    const { message: title } = data

                    if(status === 422){
                        commit('SET_VALIDATION_ERRORS', data.errors)
                    }
                    reject({title, status})
                })
        })
    },
    updateResponsibles({commit}, payload){
        commit('CLEAR_VALIDATION')
        return new Promise((resolve, reject) => {
            api.auxiliariesResponsible.update(payload)
                .then(response => {
                    const {data} = response.data

                    resolve(data)
                })
                .catch(error => {
                    const { data, status} = error.response
                    const { message: title } = data

                    if(status === 422){
                        commit('SET_VALIDATION_ERRORS', data.errors)
                    }
                    reject({title, status})
                })
        })
    },
    deleteResponsibles({commit}, payload) {
        return new Promise((resolve, reject) => {
            api.auxiliariesResponsible.delete(payload.id)
                .then(response => {
                    const {data} = response.data

                    resolve(data)
                })
                .catch(() => {
                    reject({
                        message: 'Error al eliminar el responsable.',
                    })
                })
        })
    },
}
